import momentJalali from "moment-jalali";
import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import { useHistory } from "react-router-dom";
import "react-datepicker2/src/styles/style.css";
import { setUserPop } from "../store/api/Users";
import { setDialog } from "../store/api/Modals";
import { useSelector, useDispatch } from "react-redux";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import { useEffect, useRef, useState } from "react";
import ModalSendSMS from "../../Components/Modals/ModalSendSMS";
import { Button, Card, Row } from "react-bootstrap";
import { getAllProvinces, getCityList } from "../store/api/LocationAPI";
import ModalChangeCustomerStatus from "../Components/Customer/ModalChangeCustomerStatus";
import { Search, Toggles2, List, Envelope, FileEarmarkExcelFill, EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import { searchPreCustomer, deletePreCustomer, getPreCustomerBaseInfoes, searchPreCustomer_GetMobiles } from "../store/api/CustomerApi";
import { exportToExcel, setErrorDialog } from "../../store/api/CommonFunctions";
import BihamtaTable from "../../Components/BihamtaTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const SearchPreCustomer = () => {
    const createDateTo = useRef();
    const createDateFrom = useRef();
    const updateDateTo = useRef();
    const updateDateFrom = useRef();
    const { handleSubmit, register } = useForm();
    const [showFilter, setShowFilter] = useState(true);
    const searchData = useRef({ Take: 10 });
    const [pending, setPending] = useState(false);
    const [selectedCust, setSelectedCust] = useState([]);
    const [selectedCampaign, setSelectedCampaign] = useState("");
    const [modalSMS, setModalSMS] = useState({ show: false });
    const [showChangeStatus, setChangeStatusPop] = useState(false);
    const [modalUsers, setModalUsers] = useState({ show: false });
    const { baseInfoes, provinceList, cityList, filterData } = useSelector(state => {
        return {
            baseInfoes: state.customerDataReducer.preCustomerBaseInfoes,
            filterData: state.customerDataReducer.preCustSearchFilters,
            provinceList: state.locationDataReducer.provinceList,
            cityList: state.locationDataReducer.cityList
        }
    });
    const [createBy, setCreateBy] = useState({ ID: filterData?.CreateById });
    const [updateBy, setUpdateBy] = useState({ ID: filterData?.UpdateById });

    const dispatch = useDispatch();
    useEffect(() => {
        document.body.classList = "notMain";
        dispatch(getPreCustomerBaseInfoes());
        dispatch(getAllProvinces());
        if (filterData && Object.keys(filterData).length > 0 && filterData.ForceSearch) {
            searchData.current = { ...filterData };
            search();
        }
    }, []);
    const loadCityList = (provinceID) => {
        searchData.current.ProvinceID = provinceID;
        dispatch(getCityList(provinceID));
    }
    const search = (data) => {
        if (data) {
            searchData.current = {
                ...data,
                CreationDateFrom: searchData.current.CreationDateFrom,
                CreationDateTo: searchData.current.CreationDateTo,
                UpdateDateFrom: searchData.current.UpdateDateFrom,
                UpdateDateTo: searchData.current.UpdateDateTo,
                //UpdateById : searchData.current.UpdateById,
                //CreateById: searchData.current.CreateById
            };
        }
        searchData.current.Skip = 0;
        if (!searchData.current.Take) {
            searchData.current.Take = 0;
        }
        searchData.current.CreateById = createBy.ID;
        searchData.current.UpdateById = updateBy.ID;
        if (createDateFrom.current.input.value === "") {
            searchData.current.CreationDateFrom = null;
        }
        if (createDateTo.current.input.value === "") {
            searchData.current.CreationDateTo = null;
        }
        if (updateDateFrom.current.input.value === "") {
            searchData.current.UpdateDateFrom = null;
        }
        if (updateDateTo.current.input.value === "") {
            searchData.current.UpdateDateTo = null;
        }
        dispatch(searchPreCustomer(searchData.current));
    }
    const history = useHistory();
    const showCustomer = (id) => {
        history.push("/CRM/AddEditPreCustomer/" + id);
    }
    const showCreateBy = () => {
        const setData = (data) => {
            if (data?.ID) {
                setCreateBy(data);
            }
            else {
                setCreateBy({ Name: " " });
            }
        }
        setModalUsers({ show: true, selectUserWithName: setData });
    }
    const showUpdateBy = () => {
        const setData = (data) => {
            if (data?.ID) {
                setUpdateBy(data);
            } else {
                setUpdateBy({ Name: " " });
            }
        }
        setModalUsers({ show: true, selectUserWithName: setData });
    }
    function showModalSMS() {
        const onGetMobile = (data) => {
            if (!data || !data.Data || !Array.isArray(data.Data)) {
                setErrorDialog(dispatch, data.Message ?? data.Error ?? "Error", "دریافت شماره های همراه");
                return;
            }
            const mobiles = data.Data.join(",");
            setModalSMS({
                show: true,
                to: mobiles,
                filterData: searchData.current
            })
        }
        searchPreCustomer_GetMobiles(searchData.current, onGetMobile);
    }
    function toExcel() {
        const url = "api/CustomersAPI/SearchPreCustomer";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("SearchPreCustomers", searchArgs, url, "post", tableColes, () => setPending(false));
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    const tableColes = [
        { colTitle: "ردیف", colName: "rownumber" },
        { colTitle: "نام مشتری", colName: "FirstName", justInMobile: true },
        { colTitle: "نام خانوادگی", colName: "Name", justInMobile: true },
        { colTitle: "تلفن", colName: "Phone", justInMobile: true },
        { colTitle: "همراه", colName: "Mobile", justInMobile: true },
        { colTitle: "استان", colName: "ProvinceName", justInMobile: false },
        { colTitle: "شهر", colName: "CityName", justInMobile: false },
        { colTitle: "آدرس", colName: "Address", justInMobile: false, colType: "string", maxTextLength: 100 },
        { colTitle: "وضعیت", colName: "StatusStr", justInMobile: false },
        { colTitle: "نحوه آشنایی", colName: "HowToKnowStr", justInMobile: false }
    ]
    const tableRowButtons = [
        {
            title: "حذف مشتری بالقوه", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف مشتری بالقوه',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deletePreCustomer(item.ID, search)
                }))
            }
        },
        {
            title: "تغییر وضعیت", type: "common", tooltip: "تغییر وضعیت", className: "group-Btn-smalll", icon: <Toggles2 size={20} className="rowBtn" color="#b10e9d" />, onclick: (item) => changeStatus(item)
        }

    ]
    const changeStatus = (c) => {
        const customer = {};
        customer.ID = c.ID;
        customer.CustOrPreCust = "مشتری بالقوه";
        setSelectedCust([customer]);
        setSelectedCampaign(c.CampaignID);
        setChangeStatusPop(true);
    }
    function rowClick(item) { showCustomer(item.ID); }
    return (<div className="container-fluid mt-2" style={{ minHeight: '80vh' }}>
        <br />
        <ModalChangeCustomerStatus show={showChangeStatus} setShow={setChangeStatusPop} customers={selectedCust} campaignID={selectedCampaign} onChangeStatus={() => dispatch(searchPreCustomer(filterData))} />
        <ModalSendSMS popData={modalSMS} setPopData={setModalSMS} templateType="customers" sendFromModel="customer" />
        <ModalSelectUser popData={modalUsers} setUserPop={setModalUsers} />
        <Card>
            <Card.Header className="headerStyle">
                <FontAwesomeIcon icon={faSearch} size="lg"/>&nbsp;
                جستجوی مشتریان بالقوه</Card.Header>
            <Card.Body className="bodyStyle">
                <form onSubmit={handleSubmit(search)}>
                    <Row id="divFilters" className="rowBorder">
                        <div className="rowTitle">
                            فیلترهای جستجو
                            &nbsp;
                            {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                            {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                        </div>
                        <div className="form-group col-md-2">
                                <input type='text' placeholder='نام مشتری' className="form-control" ref={register({})} name="FirstName" defaultValue={filterData?.FirstName ?? ""} />
                            </div>                        
                            <div className="form-group col-md-2">
                                <input type='text' placeholder='نام خانوادگی' className="form-control" ref={register({})} name="Name" defaultValue={filterData?.Name ?? ""} />
                            </div>
                            <div className="form-group col-md-2">
                                <input type='text' placeholder='تلفن' className="form-control" ref={register({})} name="Phone" defaultValue={filterData?.Phone ?? ""} />
                            </div>
                            <div className="form-group col-md-2">
                                <input type='text' placeholder='موبایل' className="form-control" ref={register({})} name="Mobile" defaultValue={filterData?.Mobile ?? ""} />
                            </div>
                            <div className="form-group col-md-2">
                                {baseInfoes === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {baseInfoes?.CampaignList && Array.isArray(baseInfoes.CampaignList) &&
                                    <select className='form-control' placeholder='کمپین فروش' ref={register({})} name="CampaignID" defaultValue={filterData?.CampaignID ?? ""}>
                                        <option value="">کمپین فروش را انتخاب کنید</option>
                                        <option value={-1} style={{ color: "red" }}>عضو هیچ کمپینی نباشد</option>
                                        {
                                            baseInfoes.CampaignList.map((item, i) =>
                                                <option key={i} value={item.Item1}>{item.Item2}</option>
                                            )
                                        }
                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2">
                                {provinceList === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {provinceList && Array.isArray(provinceList) &&
                                    <select className='form-control' placeholder='استان' ref={register({})} name="ProvinceID" onChange={e => loadCityList(e.target.value)} defaultValue={filterData?.ProvinceID ?? ""}>
                                        <option value="">استان را انتخاب کنید</option>
                                        {
                                            provinceList.map((item, i) =>
                                                <option key={i} value={item.Id}>{item.Name}</option>
                                            )
                                        }
                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2">
                                {cityList === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {cityList && Array.isArray(cityList) &&
                                    <select className='form-control' placeholder='شهر' ref={register({})} name="CityID" defaultValue={filterData?.CityID ?? ""}>
                                        <option value="">شهر را انتخاب کنید</option>
                                        {
                                            cityList.map((item, i) =>
                                                <option key={i} value={item.Id}>{item.Name}</option>
                                            )
                                        }
                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2">
                                <input type='text' placeholder='آدرس' className="form-control" ref={register({})} name="Address" defaultValue={filterData?.Address ?? ""} />
                            </div>
                            <div className="form-group col-md-2" >
                                {baseInfoes === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {baseInfoes?.JobList && Array.isArray(baseInfoes.JobList) &&
                                    <select className="form-control" ref={register({})} name="JobId" defaultValue={filterData?.JobId ?? ""}>
                                        <option value=""> رسته شغلی را انتخاب کنید</option>
                                        {baseInfoes.JobList.map((item, i) => <option key={i} value={item.JobId}>{item.Job}</option>)}
                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2" >
                                {baseInfoes === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {baseInfoes?.StatusList && Array.isArray(baseInfoes.StatusList) &&
                                    <select className="form-control" ref={register({})} name="StatusID" defaultValue={filterData?.StatusID ?? ""}>
                                        <option value=""> وضعیت را انتخاب کنید</option>
                                        {baseInfoes.StatusList.map((item, i) => <option key={i} value={item.ID}>{item.Status}</option>)}
                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2" >
                                {baseInfoes === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {baseInfoes?.HowToKnowList && Array.isArray(baseInfoes.HowToKnowList) &&
                                    <select className="form-control" ref={register({})} name="HowToKnow" defaultValue={filterData?.HowToKnow ?? ""}>
                                        <option value=""> نحوه آشنایی را انتخاب کنید</option>
                                        {baseInfoes.HowToKnowList.map((item, i) => <option key={i} value={item.ID}>{item.InfoName}</option>)}
                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2" >
                                {baseInfoes === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {baseInfoes?.UnwillingnessList && Array.isArray(baseInfoes.UnwillingnessList) &&
                                    <select className="form-control" ref={register({})} name="Unwillingness" defaultValue={filterData?.Unwillingness ?? ""}>
                                        <option value=""> دلیل عدم تمایل را انتخاب کنید</option>
                                        {baseInfoes.UnwillingnessList.map((item, i) => <option key={i} value={item.ID}>{item.InfoName}</option>)}
                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2" >
                                {baseInfoes === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </div>
                                }
                                {baseInfoes?.CompetitorList && Array.isArray(baseInfoes.CompetitorList) &&
                                    <select className="form-control" ref={register({})} name="CompetitorID" defaultValue={filterData?.CompetitorID ?? ""}>
                                        <option value=""> رقیب را انتخاب کنید</option>
                                        {baseInfoes.CompetitorList.map((item, i) => <option key={i} value={item.ID}>{item.Name}</option>)}
                                    </select>
                                }
                            </div>
                            <div className="form-group col-md-2" >
                                <select className="form-control" ref={register({})} name="RelatedCustomerID" defaultValue={filterData?.RelatedCustomerID ?? -1}>
                                    <option value=""> تبدیل به مشتری</option>
                                    <option value={-1}>تبدیل نشده</option>
                                    <option value={-2}>تبدیل شده</option>
                                </select>
                            </div>
                            <div className="form-group col-md-2">
                                <input className="form-control" placeholder="کاربر ثبت کننده"
                                    value={createBy && createBy.Name ? createBy.Name : ""} readOnly name="CreateByName" ref={register({})} defaultValue={filterData?.CreateByName ?? ""} />
                                <Button className="btn-input" onClick={showCreateBy} style={{ top: "7px", left: "14px" }}><List size={18} /></Button>
                            </div>
                            <div className="form-group col-md-2">
                                <input className="form-control" placeholder="کاربر ویرایش کننده"
                                    value={updateBy && updateBy.Name ? updateBy.Name : filterData?.UpdateByName ? filterData.UpdateByName : ""} readOnly name="UpdateByName" ref={register({})} />
                                <Button className="btn-input" onClick={showUpdateBy} style={{ top: "7px", left: "14px" }}><List size={18} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <DatePicker ref={createDateFrom} isGregorian={false} timePicker={false} className="form-control" placeholder="تاریخ ثبت از"
                                    onChange={value => { searchData.current.CreationDateFrom = value.local("en").format("YYYY/MM/DD") }}
                                    value={filterData?.CreationDateFrom ? momentJalali(filterData.CreationDateFrom) : searchData.current.CreationDateFrom ? momentJalali(searchData.current.CreationDateFrom) : null} />
                            </div>
                            <div className="col-md-2 form-group">
                                <DatePicker ref={createDateTo} isGregorian={false} timePicker={false} className="form-control" placeholder="تاریخ ثبت تا"
                                    value={filterData?.CreationDateTo ? momentJalali(filterData.CreationDateTo) : searchData.current.CreationDateTo ? momentJalali(searchData.current.CreationDateTo) : null}
                                    onChange={value => { searchData.current.CreationDateTo = value.local("en").format("YYYY/MM/DD") }} />
                            </div>
                            <div className="col-md-2 form-group">
                                <DatePicker ref={updateDateFrom} isGregorian={false} timePicker={false} className="form-control" placeholder="تاریخ ویرایش از"
                                    value={filterData?.UpdateDateFrom ? momentJalali(filterData.UpdateDateFrom) : null}
                                    onChange={value => { searchData.current.UpdateDateFrom = value.local("en").format("YYYY/MM/DD") }} />
                            </div>
                            <div className="col-md-2 form-group">
                                <DatePicker ref={updateDateTo} isGregorian={false} timePicker={false} className="form-control" placeholder="تاریخ ویرایش تا"
                                    value={filterData?.UpdateDateTo ? momentJalali(filterData.UpdateDateTo) : null}
                                    onChange={value => { searchData.current.UpdateDateTo = value.local("en").format("YYYY/MM/DD") }} />
                            </div>
                            <div className="form-group col-md-2">
                                <input type="number" placeholder="احتمال خرید از" className="form-control" ref={register({})} name="PurchasePossibility" defaultValue={filterData?.PurchasePossibility ?? ""} />
                            </div>
                            <div className="form-group col-md-2">
                                <input type="number" placeholder="احتمال خرید تا" className="form-control" ref={register({})} name="PurchasePossibilityTo" defaultValue={filterData?.PurchasePossibilityTo ?? ""} />
                            </div>
                            <div className="form-group col-md-2">
                                <select className="form-control" ref={register({})} name="Take" defaultValue={filterData?.Take ?? 10}>
                                    <option value={0}>تعداد در صفحه</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                            <div className="form-group col-md-2">
                                <select className="form-control" ref={register({})} name="SortBy" defaultValue={filterData?.SortBy ?? ""}>
                                    <option value="">مرتب سازی بر اساس</option>
                                    <option value="Name">نام خانوادگی-صعودی</option>
                                    <option value="Name-DESC">نام خانوادگی-نزولی</option>
                                    <option value="Date">تاریخ ایجاد</option>
                                    <option value="Date-DESC">تاریخ ایجاد-نزولی</option>
                                </select>
                            </div>
                    </Row>
                    <div className="row mt-2">
                        <div>
                            <Button style={{ float: "right" }} className="group-Btn" type="submit">
                                <Search size={15} />&nbsp;جستجوی مشتری بالقوه</Button>
                            <Button className="group-Btn" variant="secondary" onClick={showModalSMS}><Envelope size={15} />&nbsp;ارسال پیامک به لیست</Button>
                        </div>
                    </div>
                </form>
                {!pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" /></div>}
                {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} reducerName="customerDataReducer" objectName="preCustomerList" hasPaging={true}
                    searchMethod={(data) => dispatch(searchPreCustomer(data))} filterData={filterData} rowClick={rowClick} className="mt-0" style={{ whiteSpace: "nowrap" }} />
            </Card.Body>

        </Card>
    </div>
    );
}
export default SearchPreCustomer;